import React from 'react';
import { Button, FeaturedIcon } from '@myhealth-raccoon/components';
import { useNavigate } from 'react-router-dom';
import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';


export function UnexpectedError() {
    const navigate = useNavigate();

    return (<>
        <ContentContainer className='flex-1 lg:flex-none text-center space-y-6'>
            <FeaturedIcon size="lg" color="error" className="mb-8 mx-auto" />
            <h1 className="text-2xl text-gray-900 font-medium">
                We're sorry, an unexpected error occured while processing your request
            </h1>
            <p>
                Please try again or contact support if the problem persists.
            </p>

        </ContentContainer>
        <StickyBottomBar>
            <Button className="w-full"
                color='gray'
                onClick={() => navigate(-1)} >
                Try Again
            </Button>
        </StickyBottomBar>
    </>
    );
}
